




























































































































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import CompanyService from "@/services/CompanyService";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import ShareholderDTO from "@/dto/company/ShareholderDTO";
import UserDTO from "@/dto/UserDTO";
import PersonSearchModal from "@/components/common/PersonSearchModal.vue";
import CreateShareholderRequest from "@/dto/company/CreateShareholderRequest";
import PersonDTO from "@/dto/person/PersonDTO";
import OwnershipSnapshotDTO from "@/dto/company/OwnershipSnapshotDTO";
import OwnershipItemDTO from "@/dto/company/OwnershipItemDTO";
import Workspaces from "@/state/Workspaces";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import UploadK1Modal from "@/components/payroll/business/UploadK1Modal.vue";
import UpdateOwnershipModal from "@/components/profile/UpdateOwnershipModal.vue";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import Application from "@/state/Application";
import Notifications from "@/state/Notifications";
import {processError} from "@/utils/ComponentUtils";
import History from "@/components/history/History.vue";
import {HistoryDomen} from "@/components/history/dto/HistoryDomen";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component({
	computed: {
		HistoryDomen() {
			return HistoryDomen
		}
	},
	components: {History, SingleFileHolder, PortalInput, BTPortalCollapse, PortalSelect}
})
export default class Shareholders extends Vue {
  private successful = false;
  private message = "";

  @AppModule.State
  private loading!: boolean;

  @AppModule.Action
  private startLoading!: () => void;

  @AppModule.Action
  private stopLoading!: () => void;

  private shareholders: Array<ShareholderDTO> = [];
  private snapshots: Array<OwnershipSnapshotDTO> = [];
  private selectedSnapshotId: number | null = null;

  @Auth.Getter("hasAdministrativePrivileges")
  private hasAdministrativePrivileges!: boolean;

  @Auth.State
  private user!: UserDTO


  mounted() {
    this.restoreWorkspace();
  }

  restoreWorkspace() {
    this.loadShareholders();
    this.loadSnapshots();
  }

  loadShareholders() {
    this.startLoading();
    this.message = "";
    CompanyService.getAllShareHolderByCompanyId(Workspaces.getCurrent.id).then(
        response => {
          this.shareholders = response.data;
          this.successful = true;
          this.stopLoading()
        },
        error => this.errorHandle(error)
    )
  }

  loadSnapshots() {
    CompanyService.getOwnershipSnapshots(Workspaces.getCurrent.id).then(
        response => {
          this.snapshots = response.data;
          if (this.snapshots.length > 0 && !this.selectedSnapshotId) {
            // Sort snapshots by effectiveDate descending and select the latest one
            const sorted = [...this.snapshots].sort((a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime());
            this.selectedSnapshotId = sorted[0].id;
          }
        }
    )
  }

  get selectedSnapshot(): OwnershipSnapshotDTO | null {
    if (!this.selectedSnapshotId) return null;
    return this.snapshots.find(s => s.id === this.selectedSnapshotId) || null;
  }

  get snapshotOptions(): Array<SelectOption> {
    const options: Array<SelectOption> = [];
    const latestSnapshot = this.latestSnapshot;

    this.snapshots.forEach(snapshot => {
      const isActual = latestSnapshot && snapshot.id === latestSnapshot.id;
      const formattedDate = (this as any).$dateUtils.formatDateToAmericanFormat(snapshot.effectiveDate);
      options.push(new SelectOption({
        title: isActual ? 'Actual' : formattedDate,
        value: snapshot.id
      }));
    });
    return options;
  }

  getStatusClass(status: string) {
    switch (status) {
      case 'ACTIVE': return 'badge badge-success';
      case 'INACTIVE': return 'badge badge-secondary';
      case 'NEW': return 'badge badge-primary';
      default: return '';
    }
  }

  addSnapshot() {
    this.$modal.show(
        UpdateOwnershipModal,
        {
          latestSnapshot: this.latestSnapshot,
          shareholders: this.shareholders,
          onSaved: () => this.loadSnapshots()
        },
        {
          height: 'auto',
          width: 800,
          adaptive: true,
          scrollable: true
        }
    );
  }

  editSnapshot() {
    if (!this.selectedSnapshot) return;

    this.$modal.show(
        UpdateOwnershipModal,
        {
          snapshotToEdit: this.selectedSnapshot,
          shareholders: this.shareholders,
          onSaved: () => this.loadSnapshots()
        },
        {
          height: 'auto',
          width: 800,
          adaptive: true,
          scrollable: true
        }
    );
  }

  get latestSnapshot(): OwnershipSnapshotDTO | null {
    if (this.snapshots.length === 0) return null;
    return [...this.snapshots].sort((a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime())[0];
  }

  showModal() {
    this.$modal.show(
        PersonSearchModal,
        {
			title: "Choose person",
          onPersonSelected: (person: PersonDTO) => this.registerAsShareholder(person)
        }
    );
  }

  registerAsShareholder(person: PersonDTO) {
    Application.startLoading();
    const request = new CreateShareholderRequest();
    request.personId = person.id;
    request.companyId = Workspaces.getCurrent.id;
    CompanyService.createShareholder(request).then(
        () => {
          Application.stopLoading();
          Notifications.success("The shareholder has been added.");
          this.loadShareholders();
        },
        err => processError(err, this)
    )
  }

  errorHandle(error: any) {
    this.successful = false;
    this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string;
    this.stopLoading();
  }

	addNewForm(shareholderId: number) {
		this.$modal.show(
			UploadK1Modal,
			{
				onFilesUploaded: () => this.loadShareholders(),
				shareholderId: shareholderId
			});
	}

	deleteShareholder(shareholderId: number) {
	  this.$modal.show(
		  DeleteConfirmation,
		  {
			  targetName: "shareholder",
			  onDelete: () => {
				  Application.startLoading()
				  CompanyService.deleteShareholder(shareholderId).then(
					  () => {
						  Application.stopLoading()
						  Notifications.success("The shareholder has been deleted.");
						  this.loadShareholders()
					  },
					  err => processError(err, this)
				  )
			  }
		  }
	  )
	}



}
